import css from 'styled-jsx/css';
import { colors, typography } from '../../../config/styles';

const style = css`
  .create-list-button {
    display: block;
    @mixin fallback {
      display: inherit;
    }
  }
  .button-text {
    text-decoration: underline;
    color: ${colors.gray.shade15};
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    margin-left: 12px;
    margin-bottom: 23px;
    &.tottus {
      color: ${colors.teal.shade1};
    }
  }
  .csicon-add {
    color: ${colors.orange.shade4};
    font-size: ${typography.sm};
    font-weight: bolder;
    &.tottus {
      color: ${colors.teal.shade1};
    }
  }
`;
export { style };
